/* core/util/image.js */ function _(require, module, exports) {
    var logging_1 = require(167) /* ../logging */;
    var ImageLoader = /** @class */ (function () {
        function ImageLoader(url, options) {
            var _this = this;
            if (options === void 0) {
                options = {};
            }
            this._image = new Image();
            this._finished = false;
            var _a = options.attempts, attempts = _a === void 0 ? 1 : _a, _b = options.timeout, timeout = _b === void 0 ? 1 : _b;
            this.promise = new Promise(function (resolve, _reject) {
                _this._image.crossOrigin = "anonymous";
                var retries = 0;
                _this._image.onerror = function () {
                    if (++retries == attempts) {
                        var message = "unable to load " + url + " image after " + attempts + " attempts";
                        logging_1.logger.warn(message);
                        if (_this._image.crossOrigin != null) {
                            logging_1.logger.warn("attempting to load " + url + " without a cross origin policy");
                            _this._image.crossOrigin = null;
                            retries = 0;
                        }
                        else {
                            if (options.failed != null)
                                options.failed();
                            // reject(new Error(message))
                        }
                    }
                    setTimeout(function () { return _this._image.src = url; }, timeout);
                };
                _this._image.onload = function () {
                    _this._finished = true;
                    if (options.loaded != null)
                        options.loaded(_this._image);
                    resolve(_this._image);
                };
                _this._image.src = url;
            });
        }
        Object.defineProperty(ImageLoader.prototype, "finished", {
            get: function () {
                return this._finished;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ImageLoader.prototype, "image", {
            get: function () {
                return this._image;
            },
            enumerable: true,
            configurable: true
        });
        return ImageLoader;
    }());
    exports.ImageLoader = ImageLoader;
    ImageLoader.__name__ = "ImageLoader";
}
